// GENERATED FILE, DO NOT MANUALLY EDIT
import { html } from '@horizon/base';
import { HznIconBase } from '../../icon/icon-base.js';
import './types.js';
/**
 *
 * @tag hzn-icon-star-half
 * @tagname hzn-icon-star-half
 * @summary An individual icon for Horizon
 */
export class HznIconStarHalf extends HznIconBase {
    render() {
        return html `<div class="hzn-icon" aria-hidden="true"><svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.9555 0.704758C10.826 0.28575 10.4386 0 10.0001 0C9.56151 0 9.17412 0.28575 9.04464 0.704758L7.13781 6.87539H1.00007C0.571264 6.87539 0.19019 7.14877 0.0527915 7.55496C-0.0846075 7.96115 0.0522545 8.40973 0.393003 8.67004L5.401 12.4958L3.48234 18.7048C3.35391 19.1204 3.50888 19.5713 3.86565 19.8202C4.22242 20.069 4.69915 20.0587 5.04482 19.7947L10.0001 16.0092L14.9553 19.7947C15.301 20.0587 15.7777 20.069 16.1345 19.8202C16.4913 19.5713 16.6462 19.1204 16.5178 18.7048L14.5991 12.4958L19.6071 8.67004C19.9479 8.40973 20.0847 7.96115 19.9473 7.55496C19.8099 7.14877 19.4289 6.87539 19.0001 6.87539H12.8623L10.9555 0.704758ZM10.0001 4.38705V13.7508C10.214 13.7508 10.4279 13.8192 10.6071 13.9561L13.6832 16.3061L12.4823 12.4199C12.3586 12.0194 12.4977 11.5844 12.8307 11.33L16.0438 8.87539H12.1247C11.6861 8.87539 11.2987 8.58964 11.1693 8.17063L10.0001 4.38705Z" fill="currentColor"></path>
</svg></div>`;
    }
}
//# sourceMappingURL=star-half.js.map